module.exports = __webpack_public_path__ + "static/img/30_doll.ef566afb.jpg";